// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2jM2h","clinicsSelect":"styles_clinicsSelect__MYRzA"};